const DATE_TIME_LOCAL_LENGTH = 16;
const DATE_TIME_WITH_SECONDS_LENGTH = 19;
const OFFSET_PART_PADDING = 2;
const MINUTES_IN_HOUR = 60;
const POSITIVE_OFFSET_SIGN = '+';
const NEGATIVE_OFFSET_SIGN = '-';

const ISO_LOCAL_DATE_TIME_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/;

export const toDateTimeLocalValue = (value) => {
  if (!value) return '';

  // ISO date-time strings without timezone offset (e.g. "2025-01-15T15:00:00") are treated as UTC
  // since they typically originate from external APIs (football-data.org utcDate).
  // Appending 'Z' ensures new Date() interprets them as UTC rather than local time.
  const normalizedValue = typeof value === 'string' && ISO_LOCAL_DATE_TIME_PATTERN.test(value)
    ? value + 'Z'
    : value;

  const date = new Date(normalizedValue);
  if (Number.isNaN(date.getTime())) return '';

  return [
    date.getFullYear(),
    padDatePart(date.getMonth() + 1),
    padDatePart(date.getDate()),
  ].join('-') + `T${[
    padDatePart(date.getHours()),
    padDatePart(date.getMinutes()),
  ].join(':')}`;
};

export const toUserOffsetDateTime = (dateTimeLocalValue) => {
  if (!dateTimeLocalValue) return null;

  const date = new Date(dateTimeLocalValue);
  if (Number.isNaN(date.getTime())) return null;

  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? POSITIVE_OFFSET_SIGN : NEGATIVE_OFFSET_SIGN;
  const absoluteOffsetMinutes = Math.abs(offsetMinutes);
  const offsetHours = Math.floor(absoluteOffsetMinutes / MINUTES_IN_HOUR);
  const offsetRemainderMinutes = absoluteOffsetMinutes % MINUTES_IN_HOUR;

  return `${normalizeDateTimeLocalValue(dateTimeLocalValue)}${sign}${padOffsetPart(offsetHours)}:${padOffsetPart(offsetRemainderMinutes)}`;
};

// ===================================================================================================================
// = Implementation
// ===================================================================================================================

const normalizeDateTimeLocalValue = (dateTimeLocalValue) => {
  if (dateTimeLocalValue.length === DATE_TIME_LOCAL_LENGTH) {
    return `${dateTimeLocalValue}:00`;
  }

  return dateTimeLocalValue.slice(0, DATE_TIME_WITH_SECONDS_LENGTH);
};

const padDatePart = (value) => String(value).padStart(OFFSET_PART_PADDING, '0');

const padOffsetPart = (value) => String(value).padStart(OFFSET_PART_PADDING, '0');
